export default __webpack_public_path__ + "static/media/machine-tending.a92b103b.gif";